import * as angular from 'angular';
import {IController} from "angular";

export class ServicesAssignRouteTableRowCtrl implements IController {
  route: any;
  extraVolume: any;
  columns: any;
  onAssign: Function;

  private isDesktop: any;

  /* @ngInject */
  constructor(private $mdMedia) {
  }

  $onInit() {
    this.isDesktop = this.$mdMedia('gt-sm');
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('servicesAssignRouteTableRow', {
    bindings: {
      route: '<',
      columns: '<',
      extraVolume: '<?',
      onAssign: '&'
    },
    template: require('./services-assign-route-table-row.html').default,
    controller: ServicesAssignRouteTableRowCtrl
  });
